// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if ({353:1,785:1}[chunkId]) return "canvas.c1e982c101e0d82faed7.css";
	if (chunkId === 189) return "editor.a9f2a03e4331dd240a0e.css";
	if (chunkId === 35) return "player.a4379a6f23352cda07e2.css";
	if (chunkId === 231) return "checkout.71a13c2b5e41a459d872.css";
	if (chunkId === 524) return "checkoutEdu.0c8cfd4704e85155f888.css";
	if (chunkId === 559) return "gdrive.99c37209d11cb2d7f8d4.css";
	if (chunkId === 437) return "slack.30c632904b778041d8bd.css";
	// return url for filenames based on template
	return undefined;
};